export default __webpack_public_path__ + "static/media/sugar_settles.1afa7b11.svg";